export interface VttSegment {
  id: string;
  startTime: number; // in milliseconds
  endTime: number; // in milliseconds
  text: string;
}

export const parseTimestamp = (timestamp: string): number => {
  const [time, milliseconds] = timestamp.split(".");
  const [hours, minutes, seconds] = time.split(":").map(Number);

  return (
    hours * 3600 * 1000 +
    minutes * 60 * 1000 +
    seconds * 1000 +
    parseInt(milliseconds, 10)
  );
};

export const parseVTT = (vttContent: string): VttSegment[] => {
  const segments: VttSegment[] = [];
  const lines = vttContent.split("\n");

  let currentSegment: Partial<VttSegment> = {};
  let segmentId = 0;

  for (let i = 0; i < lines.length; i++) {
    const line = lines[i].trim();

    if (line === "") {
      continue;
    }

    const timestampMatch = line.match(
      /^(\d{2}:\d{2}:\d{2}\.\d{3})\s*-->\s*(\d{2}:\d{2}:\d{2}\.\d{3})/,
    );

    if (timestampMatch) {
      const startTime = parseTimestamp(timestampMatch[1]);
      const endTime = parseTimestamp(timestampMatch[2]);

      currentSegment = {
        id: `segment-${segmentId++}`,
        startTime,
        endTime,
        text: "",
      };
    } else if (
      currentSegment.startTime !== undefined &&
      currentSegment.endTime !== undefined
    ) {
      if (currentSegment.text) {
        currentSegment.text += "\n" + line;
      } else {
        currentSegment.text = line;
      }

      const nextLine = i + 1 < lines.length ? lines[i + 1].trim() : "";
      const isNextLineTimestamp = nextLine.match(
        /^\d{2}:\d{2}:\d{2}\.\d{3}\s*-->\s*\d{2}:\d{2}:\d{2}\.\d{3}/,
      );
      const isNextLineEmpty = !nextLine;

      if (isNextLineEmpty || isNextLineTimestamp || i === lines.length - 1) {
        if (currentSegment.text && currentSegment.id) {
          segments.push(currentSegment as VttSegment);
        }
        currentSegment = {};
      }
    }
  }

  return segments;
};
